import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'navigator-class-setup',
    components: {

    },
})

export default class NavigatorClassSetup extends Vue {


    // ---------------------------------------------------------------
    // Properties
    @Prop()
    private defaultCategory: any;

    @Prop()
    private selectedConfig: any;

    @Prop()
    private tenantSettings: any;

    private updatedConfig: any  = {};

    private selectedFramework: any = null;

    private hasDiagnastic: boolean = false;

    private hasRoute0: boolean = false;

    private hasAutoClassSetup: boolean = false;

    private classVersion: string = '';


    private levels: any = [
        {
            name: 'categories',
            contentList: [],
            selectedContent: null,
            action: 'categoryLists',
        },
        {
            name: 'subjects',
            contentList: [],
            selectedContent: null,
            action: 'subjectLists',
        },
        {
            name: 'frameworks',
            contentList: [],
            selectedContent: null,
            action: 'frameworkLists',
        },
    ];

    private isFrameworkLevel: boolean = false;

    private activeLevel: number = 0;

    private get activeList() {
        return this.levels[this.activeLevel];
    }

    private classVersionList: any = ['premium', 'non-premium'];

    private get activeConfig() {
        return this.selectedConfig.tenantConfig;
    }


    // --------------------------------------------------------------------------
    // Actions

    private onSelectLevel(item: any) {
        const component: any = this;
        if (this.levels.length - 1 > this.activeLevel) {
            this.isFrameworkLevel = false;
            this.levels[this.activeLevel].selectedContent = item;
            this.activeLevel++;
            if (this.levels.length - 1 === this.activeLevel) {
                this.isFrameworkLevel = true;
            }
            component[this.activeList.action](item);
            return;
        }
        this.selectedFramework = item;
    }

    private onGoBack() {
        this.isFrameworkLevel = false;
        this.hasDiagnastic = false;
        this.hasRoute0 = false;
        this.hasAutoClassSetup = false;
        if (this.activeLevel) {
            this.activeLevel--;
       }

    }

    private onChangeConfig() {
      this.$emit('onChangeConfig', this.parseConfig());
    }


    // ---------------------------------------------------------------------------------
    // Hooks

    private created() {
        const component: any = this;
        component[this.activeList.action]();
    }


    // --------------------------------------------------------------------------
    // Methods

    private subjectLists(subject: any) {
       taxonomyAPI.fetchTaxonomySubjects(subject.id).then((subjects) => {
            this.activeList.contentList = subjects;
        });
    }

    private frameworkLists(subjectDetails: any) {
        return taxonomyAPI.fetchFrameworks(subjectDetails.id).then((framework) => {
            this.activeList.contentList = framework;
            const activeSubject = this.levels[1];
            if (activeSubject.selectedContent) {
                if (this.activeConfig.value[activeSubject.selectedContent.code]) {
                   const subjectConfig = this.activeConfig.value[activeSubject.selectedContent.code];
                   this.selectedFramework = framework.find((item: any) => item.code === subjectConfig.framework);
                   this.hasDiagnastic = subjectConfig.diagnostic_applicable;
                   this.hasRoute0 = subjectConfig.route0_applicable,
                   this.classVersion = subjectConfig.class_version;
                   this.hasAutoClassSetup = subjectConfig.auto_class_setup_flag;
                }
            }
        });
    }

    private categoryLists() {
        taxonomyAPI.fetchTaxonomyClassifications().then((classification: any) => {
                const subClassification = this.tenantSettings.find(
                    (item: any) => item.key === 'tx_sub_classifier_prefs');
                if (subClassification && subClassification.value.ids) {
                    const categoryIds = subClassification.value.ids;
                    classification = classification.filter((item: any) => categoryIds.indexOf(item.id) !== -1);
                }
                this.activeList.contentList = classification;
        });
    }


    private parseConfig() {
        const framework = this.selectedFramework;
        const subject = this.levels.find((item: any) => item.name === 'subjects').selectedContent;
        return Object.assign(this.activeConfig.value || {} , {
            [subject.code]: {
                framework : framework.code,
                diagnostic_applicable: this.hasDiagnastic,
                route0_applicable: this.hasRoute0,
                student_math_level: 4,
                class_origin: 3,
                course_id: '',
                class_version: this.classVersion,
                auto_class_setup_flag: this.hasAutoClassSetup},
        });
    }


}
